import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {DlError} from 'src/js/model/error';

import {STATUS_REDUCER_STATE_ID} from './status_constants';
import {BackendInfoResponse} from './status_types';

export interface AddErrorPayload {
  item: DlError;
}

export interface RemoveErrorPayload {
  item: DlError;
}

export interface SetBackendInfoPayload {
  backendInfo: BackendInfoResponse | undefined;
}

export interface SetLastAppVersionPayload {
  lastAppVersion: string;
}

export interface SetNewVersionAvailablePayload {
  newVersionAvailable: boolean;
}

export interface StatusState {
  backendInfo: BackendInfoResponse | undefined;
  errors: DlError[];
  newVersionAvailable: boolean;
  lastAppVersion: string;
}

const initialState: StatusState = {
  backendInfo: undefined,
  errors: [],
  newVersionAvailable: false,
  lastAppVersion: '',
};

export const statusSlice = createSlice({
  name: STATUS_REDUCER_STATE_ID,
  initialState,
  reducers: {
    addError: (state, action: PayloadAction<AddErrorPayload>) => {
      const errorMessage = action.payload.item.getMessage(true);
      if (errorMessage.includes('ResizeObserver')) {
        return;
      }
      const {item} = action.payload;
      if (state.errors.findIndex((error) => error.getCategory() === item.getCategory()) === -1) {
        state.errors.push(item);
      }
    },
    clearErrors: (state) => {
      state.errors = [];
    },
    removeError: (state, action: PayloadAction<RemoveErrorPayload>) => {
      const {item} = action.payload;
      state.errors = state.errors.filter((error) => error.getCategory() === item.getCategory());
    },
    setBackendInfo: (state, action: PayloadAction<SetBackendInfoPayload>) => {
      state.backendInfo = action.payload.backendInfo;
    },
    setLastAppVersion: (state, action: PayloadAction<SetLastAppVersionPayload>) => {
      state.lastAppVersion = action.payload.lastAppVersion;
    },
    setNewVersionAvailable: (state, action: PayloadAction<SetNewVersionAvailablePayload>) => {
      state.newVersionAvailable = action.payload.newVersionAvailable;
    },
  },
});
